// removed by extract-text-webpack-plugin
module.exports = {"DateRange":"DateRange--36LFZ","Input":"Input--2aGe9"};


//////////////////
// WEBPACK FOOTER
// ./src/components/DateRange/DateRange.scss
// module id = 958
// module chunks = 1